<div fxLayout="row" fxLayoutAlign="space-between center" class="summary-class">
    <div [ngClass]="color">{{key}}</div>
    <div class="item-value">{{value}}</div>
</div>
